<template>
  <div>
    <div @click="handleOpenModal" class="direction-selector">
      <i class="fa fa-lg fa-compass direction-selector__icon"></i>
      <p class="direction-selector__title">Select on the compass</p>
    </div>

    <!-- modal with map -->
    <b-modal-custom
      title="Cardinal directions selecting tool"
      :modal-class.sync="$options.data.themeClass"
      v-model="modalDisplay"
      ok-title="Apply"
      @ok="handleOk"
      @cancel="handleCancel">

      <div class="compass-container">
        <apexchart
          :options="chartOptions"
          :series="chartSeries"/>
      </div>

    </b-modal-custom>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import BModalCustom from '@/base_components/BModalCustom'

export default {
  name: 'multiselect-direction-selector',

  components: {
    BModalCustom,
    apexchart: VueApexCharts,
  },

  props: {
    allDirections: {
      type: Array,
      default: () => [],
    },

    selectedDirections: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      modalDisplay: false,
      internalDirections: [],

      styles: {
        normalColor: '#155a7a',
        selectedColor: '#1f91bd',
      }
    };
  },

  mounted() {
    this.updateDirections();
  },

  methods: {
    handleOpenModal() {
      this.updateDirections();
      this.modalDisplay = true;
    },

    updateDirections() {
      if(!this.internalDirections.length) {
        this.internalDirections = this.getFormattedDirections();
      } else {
        this.internalDirections.forEach(direction => {
          let selected = this.selectedDirections.find(
            item => item.value === direction.value
          );
          direction.selected = !!selected;
        });
      }
    },

    getFormattedDirections() {
      return this.allDirections.map(item => {
        let selected = this.selectedDirections.find(
          direction => direction.value === item.value
        );

        return {
          value: item.value,
          text: item.text,
          selected: !!selected,
        };
      });
    },

    getSelectedDirections() {
      let selectedDirections = this.internalDirections.filter(item => item.selected);
      return selectedDirections.map(item => ({value: item.value, text: item.text}));
    },

    handleOk() {
      this.$emit('update:selected-directions', this.getSelectedDirections());
      this.$emit('input');
      this.modalDisplay = false;
    },

    handleCancel() {
      this.modalDisplay = false;
    },

    getColors(directions) {
      return directions.map((item) => {
        if(item.selected) {
          return this.styles.selectedColor;
        } else {
          return this.styles.normalColor;
        }
      });
    },

    handleDirectionSelection(event, chart, item) {
      const index = item.dataPointIndex;
      let targetItem = this.internalDirections[index];
      targetItem.selected = !targetItem.selected;

      chart.updateOptions(
        {colors: this.currentChartColors},
        false, false, true,
      );
    },
  },

  computed: {
    chartSeries() {
      let directionsCount = this.internalDirections.length;
      // returns array of equal elements [12.5, ...] in case of 8 directions
      return Array(directionsCount).fill(0).map(() => 100 / directionsCount);
    },

    initialChartColors() {
      return this.getColors(this.getFormattedDirections());
    },

    currentChartColors() {
      return this.getColors(this.internalDirections);
    },

    chartOptions() {
      return {
        chart: {
          width: '100%',
          type: 'pie',
          events: {
            dataPointSelection: this.handleDirectionSelection,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            dataLabels: {
              offset: -10,
            }
          }
        },
        colors: this.initialChartColors,
        stroke: {
          show: true,
          curve: 'smooth',
          width: 3,
          // colors: Array(16).fill(0).map(() => '#3c3c3c'),
          colors: ['#3c3c3c'],
        },

        title: {
          // text: 'Number of leads',
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
          }
        }],

        dataLabels: {
          enabled: true,
          formatter: (val, options) => {
            return this.internalDirections[options.seriesIndex].text;
          },
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Helvetica, Arial, sans-serif',
            colors: ['white'],
          },
        },
      };
    },
  },
}
</script>

<style scoped>
.compass-container {
  min-height: 300px;
}

.compass-container >>> .apexcharts-pie-area {
  cursor: pointer;
}

.compass-container >>> .apexcharts-pie-area:hover {
  fill: #1fabd9;
}
</style>

<style scoped lang="scss">
.direction-selector {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  color: #fff;
  font-weight: 500;
  background-color: #155a7a;

  &__icon {
    margin-right: 0.5rem;
  }

  &__title {
    margin: 0;
    padding: 0;
  }

  &:hover {
    background-color: #1f91bd;
  }
}
</style>
